import { takeLatest, call, select, put } from 'redux-saga/effects';

import supplierTableService from 'services/supplierTableService';

import { getGroupId } from 'store/session/selectors';

import { init, create, createModal, types } from './actions';

export default function* root() {
  yield takeLatest(types.CREATE_CUSTOM_TABLE_REQUEST, watchCreateCustomTable);
}

export function* initSupplierTablesListPage() {
  const groupId = yield select(getGroupId);
  const customTables = yield call(supplierTableService.list, groupId);
  yield put(init({ customTables }));
}

function* watchCreateCustomTable(action) {
  const groupId = yield select(getGroupId);
  const { name } = action.payload;
  try {
    const customTable = yield call(supplierTableService.create, groupId, {
      name,
    });
    yield put(create.success({ customTable }));
    yield put(createModal.close());
  } catch (error) {
    yield put(create.error(error));
  }
}
